var _effectorFileName = "/builds/gmini/front-ui-kit/src/Theme.ts";
import { createTheme } from '@mui/material';
export const muiTheme = createTheme({
  components: {
    MuiListItemIcon: {
      styleOverrides: {
        root: {
          minWidth: 24,
          marginRight: 12,
          color: 'rgba(0, 0, 0, 0.54)',
          flexShrink: 0
        }
      }
    },
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          fontSize: '0.875rem',
          letterSpacing: '0.01071em',
          lineHeight: '1.43'
        },
        'html, body, #root': {
          height: '100%',
          background: '#fff'
        }
      }
    }
  }
});